import React, { FunctionComponent } from 'react'
import { PreMatchProps } from '../MatchTypes'
import LabelFont from '../../../Theme/Fonts/Label'
import Template from '../Template'

const PreMatch: FunctionComponent<Omit<PreMatchProps, 'type'>> = ({
    additionalField1,
    additionalField2,
    awayCompetitor,
    caption,
    winner,
    minify,
    homeCompetitor,
    onPressMatch,
    matchHref,
    onPressMore,
    testID,
    isSingleMatch,
    centerComponentWidth,
    betProps,
    paddingTop,
    borderRadius,
    forceMobileView,
    onPressVideoButton,
    videoButtonHref,
    videoButtonText = 'Livestream',
}) => {
    return (
        <Template
            additionalField1={additionalField1}
            additionalField2={additionalField2}
            awayCompetitor={{
                ...awayCompetitor,
                isBold: winner === 'AWAY',
            }}
            center={
                <LabelFont textAlign="center" numberOfLines={1}>
                    {caption}
                </LabelFont>
            }
            homeCompetitor={{
                ...homeCompetitor,
                isBold: winner === 'HOME',
            }}
            minify={minify}
            isSingleMatch={isSingleMatch}
            centerComponentWidth={centerComponentWidth}
            onPressVideoButton={onPressVideoButton}
            videoButtonHref={videoButtonHref}
            videoButtonText={videoButtonText}
            onPressMatch={onPressMatch}
            matchHref={matchHref}
            onPressMore={onPressMore}
            testID={testID}
            betProps={betProps}
            paddingTop={paddingTop}
            borderRadius={borderRadius}
            forceMobileView={forceMobileView}
        />
    )
}

export default PreMatch
